/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Models_Save_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to update model configuration. Please try again." |
*
* @param {Org_Models_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_models_save_error = /** @type {((inputs?: Org_Models_Save_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Models_Save_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Modellkonfiguration konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Failed to update model configuration. Please try again.")
});